export default __webpack_public_path__ + "static/media/blockchain-image-6steg.f4fa7324.jpg";